import React from 'react'
import ReactTooltip from 'react-tooltip'
import ReviewQuestion from './ReviewQuestion/ReviewQuestion'
import styles from '../../userCard.module.scss'
import cn from 'classnames'

const ReviewItem = ({ review }) => {
  return (
    <div className={styles.review}>
      <div className={styles.reviewHeader}>
        <h4 className={styles.headerTitle}>{review.rank}</h4>
        <p className={styles.headerDate}>{review.date}</p>
      </div>
      <div className={styles.reviewBody}>
        <h4 className={styles.bodyTitle}>{review.vesselName}</h4>

        {review.questions?.map((question) => (
          <ReviewQuestion key={question.id} reviewQuestion={question} />
        ))}

        <div className={styles.reviewDescription}>
          <p
            className={cn(styles.reviewDescriptionText, { [styles.reviewDescriptionText_empty]: !review.description })}
          >
            {review.description ? review.description : 'The user chose not to leave a review'}
          </p>
        </div>
      </div>
      <div className={styles.reviewFooter}>
        <h5 className={styles.footerTitle}>
          From{' '}
          <b data-tip={true} data-for={review.seafarerName}>
            {review.seafarerName}
          </b>
        </h5>

        {review?.seafarerName?.length >= 75 && (
          <ReactTooltip backgroundColor="#06251e" place="top" id={review.rank}>
            {review.seafarerName}
          </ReactTooltip>
        )}
      </div>
    </div>
  )
}
//
export default ReviewItem
